import React from 'react';
import { t } from '../../../modules/infra/i18n';
import Row from './components/Row';

class Common {
  renderCustomerNotification() {} // eslint-disable-line
  renderArrived() {} // eslint-disable-line
  renderBarberNotification() {} // eslint-disable-line
  renderReminders() {} // eslint-disable-line

  render() {
    const { disabled, commonHiddenFields } = this.props;

    return (
      <div className="layout__item">
        <div className="layout">
          <div className="layout__item u-1/2">
            <div className="c-heading c-heading--lightgrey u-pb u--ml">
              {t('admin:shops.add.preferred_notification_methods')}
            </div>
          </div>
        </div>

        <div className="layout">
          <div className="layout__item u-1/2">
            <Row
              disabled={disabled}
              className="u-mb-"
              label={t('admin:shops.add.confirm_label')}
              action="notifications.confirm"
              hide={commonHiddenFields}
            />
            <Row
              disabled={disabled}
              className="u-mb-"
              label={t('admin:shops.add.reschedule_label')}
              action="notifications.reschedule"
              hide={commonHiddenFields}
            />
            <Row
              disabled={disabled}
              className="u-mb-"
              label={t('admin:shops.add.cancel_label')}
              action="notifications.cancel"
              hide={commonHiddenFields}
            />
            {this.renderArrived()}
          </div>
          <div className="layout__item u-1/2">{this.renderReminders()}</div>
        </div>
      </div>
    );
  }
}

export default Common;
